import * as React from "react";
import * as classNames from "classnames";
import { backgroundStyleFromNode } from "../../../helpers/Doc/changes";

function AiAssistantFeedback(props: any) {
  const [content, setContent] = React.useState("");
  const response: "You did a commendable job establishing rapport with Mr. Aiken right from the beginning. You introduced yourself warmly and made it clear that you were working with Dr. Sloan, helping Mr. Aiken feel comfortable and connected in the medical environment. Your initial question was open-ended and inviting, allowing Mr. Aiken to share his primary concern without leading him or narrowing his focus prematurely. This approach is excellent for gathering a broad picture of the patient's condition." = "You did a commendable job establishing rapport with Mr. Aiken right from the beginning. You introduced yourself warmly and made it clear that you were working with Dr. Sloan, helping Mr. Aiken feel comfortable and connected in the medical environment. Your initial question was open-ended and inviting, allowing Mr. Aiken to share his primary concern without leading him or narrowing his focus prematurely. This approach is excellent for gathering a broad picture of the patient's condition.";

  return (
    <div
      id={props.uid}
      data-is-node
      data-uid={props.uid}
      className={classNames("ai-assistant-feedback", props.uid)}
      style={backgroundStyleFromNode(props)}
    >
      <div className="ai-response-body">
        {response}
      </div>
    </div>
  );
}

export default React.memo(AiAssistantFeedback);